// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import SignInPage from './pages/SignInPage/SignInPage';
import SignUpPage from './pages/SignUpPage/SignUpPage';
import LeadsPage from './pages/LeadsPage/LeadsPage';
import CreateLead from './pages/LeadsPage/CreateLead';
import LeadDetails from './pages/LeadsPage/LeadDetails';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import PrivateRoute from './utils/PrivateRoute/PrivateRoute';
//import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Navigate } from "react-router-dom";
import { Toolbar } from '@mui/material';
import EditLead from './pages/LeadsPage/EditLead';
import TasksPage from './pages/TasksPage/TasksPage';
import CreateTask from './pages/TasksPage/CreateTask';
import EditTask from './pages/TasksPage/EditTask';
import AdminPage from './pages/AdminPage/AdminPage';
import EditUserPage from './pages/AdminPage/EditUser';
import ContactsPage from './pages/ContactsPage/ContactsPage';
import CreateContact from './pages/ContactsPage/CreateContact';
import EditContact from './pages/ContactsPage/EditContact';
import ContactDetails from './pages/ContactsPage/ContactDetails';
import AccountsPage from './pages/AccountsPage/AccountsPage';
import AccountDetails from './pages/AccountsPage/AccountDetails';
import CreateAccount from './pages/AccountsPage/CreateAccount';
import EditAccount from './pages/AccountsPage/EditAccount';
import CampaignsPage from './pages/CampaignsPage/CampaignsPage';
import CreateCampaign from './pages/CampaignsPage/CreateCampaign';
import CampaignDetails from './pages/CampaignsPage/CampaignDetails';
import EditCampaign from './pages/CampaignsPage/EditCampaign';
import DealsPage from './pages/DealsPage/DealsPage';
import CreateDeal from './pages/DealsPage/CreateDeal';
import EditDeal from './pages/DealsPage/EditDeal';
import DealDetails from './pages/DealsPage/DealDetails';
import ProposalsPage from './pages/ProposalsPage/ProposalsPage';
import CreateProposal from './pages/ProposalsPage/CreateProposal';
import EditProposal from './pages/ProposalsPage/EditProposal';
import ProposalDetails from './pages/ProposalsPage/ProposalDetails';
import { Box } from '@mui/material';
import ConfirmInvitation from './pages/ConfirmInvitationPage/ConfirmInvitationPage';
import { Toaster } from 'sonner';
import ForgotPassword from './pages/ForgotPasswordPage/ForgotPassword';
import ResetPassword from './pages/ResetPasswordPage/ResetPassword';
import GlobalSearch from './pages/GlobalSearchPage/GlobalSearch';
import ReportsPage from './pages/ReportsPage/ReportsPage';
import CreateReport from './pages/ReportsPage/CreateReport';
import ReportViewer from './components/Reports/ReportViewer';
import EditReport from './pages/ReportsPage/EditReport';
import AnalyticsPage from './pages/AnalyticsPage/AnalyticsPage';


const App = () => {
  return (
    <Router>
      
        <ErrorBoundary>
          <Box className="app" sx={{ height: '100vh'}}>
            <ConditionalHeader />
            <main>
            <Toaster richColors />
              <Routes>
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <Navigate to="/home" replace />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <PrivateRoute>
                      <HomePage />
                    </PrivateRoute>
                  }
                />
                <Route path="/leads">
                  <Route index element={<PrivateRoute><LeadsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateLead /></PrivateRoute>} />
                  <Route path=":leadId" element={<PrivateRoute><LeadDetails /></PrivateRoute>} />
                  <Route path="edit/:leadId" element={<PrivateRoute><EditLead /></PrivateRoute>} />
                </Route>
                <Route path="/contacts">
                  <Route index element={<PrivateRoute><ContactsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateContact /></PrivateRoute>} />
                  <Route path=":leadId" element={<PrivateRoute><ContactDetails /></PrivateRoute>} />
                  <Route path="edit/:leadId" element={<PrivateRoute><EditContact /></PrivateRoute>} />
                </Route>
                <Route path="/accounts">
                  <Route index element={<PrivateRoute><AccountsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateAccount /></PrivateRoute>} />
                  <Route path=":accountId" element={<PrivateRoute><AccountDetails /></PrivateRoute>} />
                  <Route path="edit/:accountId" element={<PrivateRoute><EditAccount /></PrivateRoute>} />
                </Route>
                <Route path="/campaigns">
                  <Route index element={<PrivateRoute><CampaignsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateCampaign /></PrivateRoute>} />
                  <Route path=":campaignId" element={<PrivateRoute><CampaignDetails /></PrivateRoute>} />
                  <Route path="edit/:campaignId" element={<PrivateRoute><EditCampaign /></PrivateRoute>} />
                </Route>
                <Route path="/deals">
                  <Route index element={<PrivateRoute><DealsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateDeal /></PrivateRoute>} />
                  <Route path=":dealId" element={<PrivateRoute><DealDetails /></PrivateRoute>} />
                  <Route path="edit/:dealId" element={<PrivateRoute><EditDeal /></PrivateRoute>} />
                </Route>
                <Route path="/proposals">
                  <Route index element={<PrivateRoute><ProposalsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateProposal /></PrivateRoute>} />
                  <Route path=":proposalId" element={<PrivateRoute><ProposalDetails /></PrivateRoute>} />
                  <Route path="edit/:proposalId" element={<PrivateRoute><EditProposal /></PrivateRoute>} />
                </Route>
                <Route path="/tasks">
                  <Route index element={<PrivateRoute><TasksPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateTask /></PrivateRoute>} />
                  <Route path=":taskId" element={<PrivateRoute><EditTask /></PrivateRoute>} />
                </Route>

                <Route path="/globalsearch">
                  <Route index element={<PrivateRoute><GlobalSearch /></PrivateRoute>} />
                </Route>

                <Route path="/reports">
                  <Route index element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
                  <Route path="create" element={<PrivateRoute><CreateReport /></PrivateRoute>} />
                  <Route path=":reportId" element={<PrivateRoute><ReportViewer /></PrivateRoute>} />
                  <Route path="edit/:reportId" element={<PrivateRoute><EditReport /></PrivateRoute>} />
                </Route>

                <Route path="/analytics">
                  <Route index element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
                </Route>

                <Route path="/admin">
                  <Route index element={<PrivateRoute><AdminPage /></PrivateRoute>} />
                  <Route path=":userId" element={<PrivateRoute><EditUserPage /></PrivateRoute>} />
                </Route>
                {/* <Route path="/leads">
                  <Route index element={<LeadsPage />} />
                  <Route path="create" element={<CreateLead />} />
                </Route> */}

                <Route path="/signin" element={<SignInPage />} />
                {/* <Route path="/signup" element={<SignUpPage />} /> */}
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/confirm-invitation/:token" element={<ConfirmInvitation />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                <Route path="*" element={<div> Not Found or You do not have permission.</div>}/>

              </Routes>
            </main>
            <Footer />
          </Box>
        </ErrorBoundary>
     
    </Router>
  );
};

const ConditionalHeader = () => {
  const location = useLocation();
  const hideHeaderPaths = ['/signin', '/signup', '/confirm-invitation', '/forgot-password', '/reset-password'];

  if (hideHeaderPaths.some((path) => location.pathname.startsWith(path))) {
    return null;
  }

  return <Header />;
};

export default App;
